export const PERMISSION_DENIED = 1;
export const geolocationSupported = () => typeof navigator !== 'undefined' && 'geolocation' in navigator;
// Tells the caller what the visitor answered before, then again whenever that answer changes.
// Some browsers cannot say; they report null and the caller has to wait for the visitor to ask.
// Returns a function that stops listening.
export const watchGeolocationPermission = (onState) => {
    let cancelled = false;
    let status = null;
    const apply = (state) => {
        if (!cancelled)
            onState(state);
    };
    if (!navigator.permissions)
        apply(null);
    else {
        navigator.permissions.query({ 'name': 'geolocation' })
            .then(s => {
            status = s;
            apply(s.state);
            s.onchange = () => apply(s.state);
        })
            .catch(() => apply(null));
    }
    return () => {
        cancelled = true;
        if (status !== null)
            status.onchange = null;
    };
};
